import React, { useState, useEffect } from 'react';
import Dashboard from './components/Dashboard';
import Editor from './components/Editor';
import Auth from './components/Auth';
import { Toaster } from './components/ui/sonner';
import { supabase } from './supabaseClient';
import { SubscriptionProvider } from './contexts/SubscriptionContext';
import { ProjectsProvider } from './contexts/ProjectsContext';
import { TemplatesProvider } from './contexts/TemplatesContext';

const App = () => {
  const [user, setUser] = useState(null);
  const [currentProject, setCurrentProject] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (supabase) {
      supabase.auth.getSession().then(({ data: { session } }) => {
        setUser(session?.user ?? null);
        setLoading(false);
      });

      const { data: { subscription } } = supabase.auth.onAuthStateChange((_event, session) => {
        setUser(session?.user ?? null);
        setLoading(false);
      });

      return () => subscription.unsubscribe();
    } else {
      setLoading(false);
    }
  }, []);

  if (loading) {
    return <div className="flex h-screen items-center justify-center">Loading...</div>;
  }

  if (!user) {
    return (
      <>
        <Auth supabase={supabase} onLogin={setUser} />
        <Toaster />
      </>
    );
  }

  return (
    <SubscriptionProvider>
      <ProjectsProvider>
        <TemplatesProvider>
          {currentProject ? (
            <Editor
              user={user}
              supabase={supabase}
              project={currentProject}
              onBack={() => setCurrentProject(null)}
              onLogout={() => supabase.auth.signOut()}
            />
          ) : (
            <Dashboard
              user={user}
              supabase={supabase}
              onSelectProject={setCurrentProject}
              onLogout={() => supabase.auth.signOut()}
            />
          )}
          <Toaster />
        </TemplatesProvider>
      </ProjectsProvider>

    </SubscriptionProvider>
  );

};

export default App;
